import GaiaBrazeProvider from './GaiaBrazeProvider'

export default GaiaBrazeProvider
// eslint-disable-next-line import/export
export * from './GaiaBrazeProvider'
